import createUniversalPresetInternal from '../presets/universal';
import { createFeatureFlagsFromProps } from '../utils/feature-flags-from-props';
import { getDefaultPresetOptionsFromEditorProps } from './create-plugins-list';

// Separate file, we should not accidentally import this into the `ComposableEditor`
// otherwise it will blow up the bundle size.
export function createUniversalPreset(_ref) {
  var _props$dangerouslyApp;
  var props = _ref.props,
    prevProps = _ref.prevProps,
    initialPluginConfiguration = _ref.initialPluginConfiguration;
  var preset = createUniversalPresetInternal({
    appearance: props.appearance,
    props: getDefaultPresetOptionsFromEditorProps(props),
    initialPluginConfiguration: initialPluginConfiguration,
    featureFlags: createFeatureFlagsFromProps(props.featureFlags),
    prevAppearance: prevProps === null || prevProps === void 0 ? void 0 : prevProps.appearance
  });
  return withDangerouslyAppendPlugins(preset)((_props$dangerouslyApp = props.dangerouslyAppendPlugins) === null || _props$dangerouslyApp === void 0 ? void 0 : _props$dangerouslyApp.__plugins);
}
function withDangerouslyAppendPlugins(preset) {
  function createEditorNextPluginsFromDangerouslyAppended(plugins
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) {
    return plugins ? plugins.map(function (plugin) {
      return function () {
        return plugin;
      };
    }) : [];
  }
  return function (editorPluginsToAppend) {
    if (!editorPluginsToAppend || editorPluginsToAppend.length === 0) {
      return preset;
    }
    var nextEditorPluginsToAppend = createEditorNextPluginsFromDangerouslyAppended(editorPluginsToAppend);
    var presetWithAppendedPlugins = nextEditorPluginsToAppend.reduce(function (acc, plugin) {
      // These are dangerously appended, we don't need their type information leaking into
      // universal preset
      // @ts-expect-error
      return acc.add(plugin);
    }, preset);
    return presetWithAppendedPlugins;
  };
}